export default "__VITE_ASSET__BYrMKT4P__"